export const AUTH_HOME_PARAM = 'cleic_auth_home';
export const HANDOFF_RETRY_PARAM = 'cleic_handoff_retry';
export const AUTH_STATUS_PARAM = 'cleic_auth_status';
export const DEFAULT_AUTH_HOME_ORIGIN = 'https://auth.cleic.com';

const SAFE_AUTH_STATUSES = new Set([
  'handoff_restore_failed',
  'invalid_session',
  'no_session_after_handoff',
]);

const CLEIC_WWW_PREVIEW_HOST_RE = /^cleic-www-hub-git-[a-z0-9-]+-genex-ecosystem\.vercel\.app$/;

const ALLOWED_AUTH_HOME_ORIGINS = new Set([
  DEFAULT_AUTH_HOME_ORIGIN,
  'https://account.cleic.com',
  'https://cleic.com',
  'https://www.cleic.com',
  'https://cleic-www-hub.vercel.app',
  'http://localhost:5180',
]);

export function parseHandoffRetryCount(search) {
  const value = new URLSearchParams(search).get(HANDOFF_RETRY_PARAM);
  const count = value ? Number.parseInt(value, 10) : 0;
  return Number.isFinite(count) && count > 0 ? count : 0;
}

export function shouldInterruptNoSessionAfterHandoff(search) {
  return parseHandoffRetryCount(search) >= 1;
}

export function buildReturnToUrl(origin, pathWithSearch, status) {
  const url = new URL(pathWithSearch, origin);
  url.searchParams.set(HANDOFF_RETRY_PARAM, String(parseHandoffRetryCount(url.search) + 1));
  if (SAFE_AUTH_STATUSES.has(status)) {
    url.searchParams.set(AUTH_STATUS_PARAM, status);
  }
  return url.toString();
}

export function buildInitialReturnToUrl(origin, pathWithSearch) {
  return new URL(pathWithSearch, origin).toString();
}

export function buildFreshRetryReturnTo(origin, pathWithSearch) {
  const url = new URL(pathWithSearch, origin);
  url.searchParams.delete(HANDOFF_RETRY_PARAM);
  url.searchParams.delete(AUTH_STATUS_PARAM);
  url.searchParams.delete(AUTH_HOME_PARAM);
  return url.toString();
}

function isAllowedPreviewAuthHome(url) {
  return url.protocol === 'https:' && CLEIC_WWW_PREVIEW_HOST_RE.test(url.hostname);
}

export function isAllowedAuthHomeOrigin(candidate) {
  try {
    const url = new URL(candidate);
    return ALLOWED_AUTH_HOME_ORIGINS.has(url.origin) || isAllowedPreviewAuthHome(url);
  } catch {
    return false;
  }
}

export function resolveAuthHomeOrigin(candidate, fallback = DEFAULT_AUTH_HOME_ORIGIN) {
  if (candidate && isAllowedAuthHomeOrigin(candidate)) {
    return new URL(candidate).origin;
  }
  if (fallback && isAllowedAuthHomeOrigin(fallback)) {
    return new URL(fallback).origin;
  }
  return DEFAULT_AUTH_HOME_ORIGIN;
}
